import { PRESERVED_QUERY_PARAMS_KEY } from '@oas/constants/constants';

const PRESERVED_QUERY_PARAMS_TTL_MS = 60 * 60 * 1000;

type PreservedQueryParams = {
    queryData?: Record<string, string>;
    expiration?: number;
};

function removePreservedQueryParamsIfExpired() {
    const preservedQueryParams = localStorage.getItem(
        PRESERVED_QUERY_PARAMS_KEY
    );

    if (!preservedQueryParams) {
        return;
    }

    try {
        const parsedValue = JSON.parse(
            preservedQueryParams
        ) as PreservedQueryParams;

        if ((parsedValue.expiration ?? 0) < Date.now()) {
            localStorage.removeItem(PRESERVED_QUERY_PARAMS_KEY);
        }
    } catch {
        localStorage.removeItem(PRESERVED_QUERY_PARAMS_KEY);
    }
}

export function preserveCurrentQueryParamsInStorage() {
    const currentSearch = window.location.search;

    if (!currentSearch) {
        removePreservedQueryParamsIfExpired();
        return;
    }

    try {
        const queryData = Object.fromEntries(
            new URLSearchParams(currentSearch).entries()
        );

        if (Object.keys(queryData).length === 0) {
            return;
        }

        localStorage.setItem(
            PRESERVED_QUERY_PARAMS_KEY,
            JSON.stringify({
                queryData,
                expiration: Date.now() + PRESERVED_QUERY_PARAMS_TTL_MS,
            })
        );
    } catch {
        return;
    }
}
